import { Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, ValidationErrors } from '@angular/forms';
import { Subject } from 'rxjs';

/**
 * @deprecated
 */
@Component({
  selector: 'partnerhub-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true,
    },
  ],
})
export class CheckboxComponent implements OnInit, OnDestroy, ControlValueAccessor {
  get invalid(): boolean {
    return this.touched && this.errors !== null;
  }

  private readonly complete$ = new Subject();

  @Input() public errors: ValidationErrors = null;

  @Input() public groupName: string;

  public isDisabled = false;

  @Input() public label: string;

  @Input() public onChangeEvent: (...args: any) => void | null;

  public touched = false;

  public value = null;

  constructor() {}

  public ngOnDestroy() {
    this.complete$.next(true);

    this.complete$.complete();
  }

  public ngOnInit(): void {}

  public onBlur() {
    this.touched = true;
  }
  public onChange = (_: any) => {};

  public onCheckChange(event): void {
    this.value = event.target.checked;
    this.onChangeEvent ? this.onChangeEvent(this.value) : null;
    this.onChange(this.value);
  }

  public onTouch = () => {};

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  public writeValue(value: any): void {
    this.value = value;

    this.onChange(this.value);
  }
}
